import React from 'react';
import lightPurpleIcon from './images/light-purple-icon.svg';
import lightGrayIcon from './images/light-gray-icon.svg';
import wifiIcon from './images/wifi-icon.svg';
import billIcon from './images/bill-icon.svg';
import phoneIcon from './images/phone-icon.svg';
import simIcon from './images/sim-icon.svg';
import checkmarkPurpleIcon from './images/checkmark-purple-icon.svg';
import checkmarkGrayIcon from './images/checkmark-gray-icon.svg';
import appleIcon from './images/apple-icon.svg';
import androidIcon from './images/android-icon.svg';
import alertIcon from './images/alert-icon.svg';

const Instructions = (props) => {
  const getIcon = (iconType) => {
    switch (iconType) {
      case 1:
        return <span className='icon light-purple' style={{backgroundImage:lightPurpleIcon.bg()}}></span>;
      case 2:
        return <span className='icon light-gray' style={{backgroundImage:lightGrayIcon.bg()}}></span>;
      case 3:
        return <span className='icon wifi' style={{backgroundImage:wifiIcon.bg()}}></span>;
      case 4:
        return <span className='icon bill' style={{backgroundImage:billIcon.bg()}}></span>;
      case 5:
        return <span className='icon phone' style={{backgroundImage:phoneIcon.bg()}}></span>;
      case 6:
        return <span className='icon esim'></span>;
      case 7:
        return <span className='icon sim'></span>;
      case 8:
        return <span className='icon checkmark-purple' style={{backgroundImage:checkmarkPurpleIcon.bg()}}></span>;
      case 9:
        return <span className='icon checkmark-gray' style={{backgroundImage:checkmarkGrayIcon.bg()}}></span>;
      case 10:
        return <span className='icon apple' style={{backgroundImage:appleIcon.bg()}}></span>;
      case 11:
        return <span className='icon android' style={{backgroundImage:androidIcon.bg()}}></span>;
      case 12:
        return <span className='icon alert' style={{backgroundImage:alertIcon.bg()}}></span>;
      default:
        return null;
    }
  };

  return (
    <div className='cellular-instructions-wrapper'>
      {props.details?.map((detail, index) => {
        return (
          <div className='details' key={index}>
            {getIcon(detail.icon)}
            <div>
              {detail.title && <div className='title'>{detail.title}</div>}
              {detail.text && <p className={detail.isBoldText ? 'bold-text' : ''}>{detail.text}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Instructions;
